class JobsFilter {
  constructor(rootSelector) {
    this.root = document.querySelector(rootSelector);

    if (!this.root) {
      return;
    }

    this.groups = this.root.querySelectorAll('[data-jobs-filter-group]');
    this.groups.forEach((group) => {
      this.initGroup(group);
    });

    this.root.addEventListener('submit', (event) => {
      event.preventDefault();
      this.submitWithoutEmptyParams();
    });

    const resetButton = this.root.querySelector('[data-jobs-filter-reset]');

    if (resetButton) {
      resetButton.addEventListener('click', () => {
        window.location.href = this.root.action;
      });
    }
  }

  submitWithoutEmptyParams() {
    const params = new URLSearchParams();
    const formData = new FormData(this.root);

    formData.forEach((value, key) => {
      const trimmed = String(value).trim();

      if (trimmed !== '') {
        params.append(key, trimmed);
      }
    });

    const query = params.toString();
    const action = this.root.action || window.location.pathname;

    window.location.href = query ? `${action}?${query}` : action;
  }

  initGroup(group) {
    const radios = Array.from(group.querySelectorAll('input[type="radio"]'));

    if (!radios.length) {
      return;
    }

    const syncGroup = () => {
      radios.forEach((radio) => {
        const label = radio.closest('.p-jobs__filter-chip');

        if (label) {
          label.classList.toggle('is-active', radio.checked);
        }
      });
    };

    radios.forEach((radio) => {
      radio.addEventListener('change', syncGroup);
    });

    syncGroup();
  }
}
